import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const NatureValley = ({featuredProjectsList}) => {
  const project = getProject('nature-valley');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            video: '42582327',
            posterVideo: '215916986',
            posterImage: '//yourmajestyco.imgix.net/20170509005157/slide2-og.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            The Trail View project was born out of Nature Valley’s commitment to
            nature and their mission to preserve it.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20170509005157/slide2-og.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            It was the first-of-its-kind hiking experience and glimpse into
            America’s National Parks using Street View technology, and to pull
            it off we hiked, climbed, and captured over 400 miles of 360°
            photo-views across the country.
          </p>
        </AnimateIn>

        <Image
          className="component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503204220/13.jpg'
          }}
        />

        <Image
          className="component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170509005156/slide1.jpg'
          }}
        />

        <Image
          component={{
            image: '//images.yourmajesty.co/20170503204223/32.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="trail-view-2-0">Trail View 2.0</h2>
          <p>
            Choosing from Grand Canyon, Yellowstone, Great Smoky Mountains and
            Sequoia, hikers can pick one of the parks and explore its trails in
            depth via a topographic map. Trail View 2.0 also highlights Nature
            Valley’s preservation efforts, flora and fauna and mobile-optimized
            experience.
          </p>
        </AnimateIn>

        <VimeoVideo
          className="g-row"
          component={{
            video: '41114976',
            posterImage: '//images.yourmajesty.co/20170503204359/poster.jpg',
            caption: 'Behind the scenes'
          }}
        />

        <Quote
          className="g-row quote--marks"
          component={{
            quote:
              'They ported the Street View 360 technology into creating the original, unprecedented Trail View platform.',
            quotee: 'Google'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503204225/52.jpg',
            caption:
              'Catherine and Geoff, planning the route on the third day in the Sequoia National Park, California.'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503204227/72.jpg',
            caption:
              'Peter, Brandon, Greg and Catherine preparing their three star Michelin dinner.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="milestones">Milestones</h2>
          <ul>
            <li>38.4 million media impressions.</li>
            <li>Brand fanbase up 16,000+.</li>
            <li>$1.3 mil raised and donated for conservation.</li>
            <li>10x growth in visitors.</li>
            <li>Average 3:41 min spent on site following broadcast spot.</li>
            <li>Featured in IDEO’s lecture series.</li>
            <li>
              34 awards including 2x Cannes Cyber Lions, 2x Clios, and 2x Webby
              wins.
            </li>
          </ul>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>
            McCann NY
            <br />
            InTheMo Interactive
            <br />
            <em>Backpacker Magazine</em>
          </p>
        </AnimateIn>

        <LinkList
          component={{
            title: 'Press',
            useLinksDirectly: true,
            links: [
              {
                title:
                  'A Street View-Style Tour Of National Parks Hiking Trails, Courtesy Of Nature Valley',
                url:
                  'https://www.fastcompany.com/1790419/street-view-style-tour-national-parks-hiking-trails-courtesy-nature-valley',
                source: 'Fast Company'
              },
              {
                title:
                  'Marketers Promoting a Granola Bar Hit the Trails in National Parks',
                url:
                  'http://www.nytimes.com/2012/03/08/business/media/virtual-hikes-promote-nature-valley-granola-bars.html',
                source: 'The New York Times'
              },
              {
                title:
                  'Hike Yellowstone From Home: Nature Valley Releases Virtual Park Tours',
                url:
                  'http://www.cntraveler.com/stories/2012-03-07/nature-valley-granola-national-parks-view-hiking',
                source: 'Condé Nast Traveler'
              },
              {
                title:
                  'Trail View captures 300 miles of US national park trails in 360 degrees',
                url:
                  'https://www.theverge.com/2012/3/8/2854332/nature-valley-trail-view-national-park-virtual-tour',
                source: 'The Verge'
              },
              {
                title:
                  'Nature Valley Trail View, Celebrated Digital Campaign for the National Parks, Gets an Update',
                url:
                  'http://www.adweek.com/creativity/nature-valley-trail-view-celebrated-digital-campaign-national-parks-gets-update-148895/',
                source: 'Adweek'
              },
              {
                title: 'Nature Valley Trail View',
                url:
                  'https://www.thinkwithgoogle.com/intl/en-gb/campaigns/general-mills-nature-valley-trail-view.html',
                source: 'Think with Google'
              },
              {
                title: 'Nature Valley Trail View 2.0',
                url:
                  'https://www.thinkwithgoogle.com/campaigns/general-mills-nature-valley-trail-view.html',
                source: 'Think with Google'
              },
              {
                title:
                  'Nature Valley Offering ‘Street View’ for Hiking U.S. Parks',
                url: 'http://www.pcmag.com/article2/0,2817,2402065,00.asp',
                source: 'PCMag'
              },
              {
                title:
                  'SXSW: Virtually Hike National Parks With Nature Valley’s Trail View',
                url:
                  'http://www.popularmechanics.com/culture/web/a7547/sxsw-virtually-hike-national-parks-with-nature-valleys-trail-view-7358691/',
                source: 'Popular Mechanics'
              }
            ]
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Creative Strategy',
                  'Launch Strategy',
                  'Prototyping & Validation',
                  'Research',
                  'Technical Strategy'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Creative Direction',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Front-end Development',
                  'Functional Prototyping'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'Analytics & Insights',
                  'Launch',
                  'Optimization',
                  'Quality Assurance'
                ]
              },

              {
                title: 'Content',
                items: ['Photography', 'Post Production']
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default NatureValley;
